import 'react-datepicker/dist/react-datepicker.css'
import './DateTimePicker.scss'

import DatePicker from 'react-datepicker'
import { useEffect, useState } from 'react'
import { DateTime } from 'luxon'

const DateTimePicker = ({ control, label, onChange, date = true, time = true, disabled, defaultValue }) => {
    const dateFormat = `${date ? 'MMMM d, yyyy' : ''} ${time ? 'HH:mm' : ''}`.trim()
    const timeFormat = 'HH:mm'

    const parseInput = (value) => {
        if (value && typeof value === 'string') {
            const [h, m] = value.split(':').map(Number)
            return DateTime.local().set({ hour: h, minute: m, second: 0, millisecond: 0 }).toJSDate()
        } else if (value && typeof value === 'number') {
            const datetime = DateTime.fromMillis(value, { zone: 'utc' })
            return new Date(datetime.year, datetime.month - 1, datetime.day, datetime.hour, datetime.minute)
        } else {
            return null
        }
    }

    const [selectedValue, setSelectedValue] = useState()
    
    const onDateTimeChange = (value) => {
        setSelectedValue(value)

        let newValue
        if (value) {
            if (date) {
                const { year, month, day, hour, minute } = DateTime.fromJSDate(value)

                if (time) {
                    newValue = DateTime.utc(year, month, day, hour, minute).toMillis()
                } else {
                    newValue = DateTime.utc(year, month, day, 0, 0).toMillis()
                }
            } else {
                newValue = DateTime.fromJSDate(value, { zone: 'local' }).toFormat('HH:mm')
            }
            if (control) control.setValue(newValue)
            if (onChange) onChange(newValue)
        }
    }

    const updateFromValue = (value) => {
        if (selectedValue?.getTime() !== parseInput(value)?.getTime()) {
            setSelectedValue(parseInput(value))
            if (onChange) onChange(value)
        }
    }

    useEffect(() => {
        updateFromValue(control ? control.value : defaultValue)
    }, [control?.value])

    return (
        <div className="datetime flex-column">
            {label && <label>{label}</label>}
            <div className="position-relative">
                <DatePicker showTimeSelect={time} showTimeSelectOnly={!date} onChange={onDateTimeChange} selected={selectedValue} dateFormat={dateFormat} timeFormat={timeFormat} disabled={disabled} locale={'en-GB'} />
            </div>
        </div>
    )
}

export default DateTimePicker